module.exports = __webpack_public_path__ + "img/thermal.ee7e7f4c.png";